// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  width: 100%;
  margin-bottom: 6px;
}

.checkbox-price {
  color: #b5b5b5;
}

.hidden {
  visibility: hidden;
}

.price {
  margin-right: 10px;
}

.qty__btn {
  width: 24px;
  height: 24px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 19px;
  color: white;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
  color: var(--ion-color-primary);
}

ion-checkbox {
  margin: 0 12px 0 0;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #FFFFFF;
  border: 0.5px solid #E2DCD5;
  border-radius: 10px;
  margin: 10px 0px;
}

ion-label {
  font-size: 14px;
  font-family: AppFont, sans-serif;
}
@media (min-width: 991px) {
  ion-label {
    padding-right: 5px;
  }
}

.item-img {
  width: 50px;
  padding: 7px;
}

.mehr-articles {
  width: -moz-fit-content;
  width: fit-content;
}
.mehr-articles div {
  background: white;
  border: 1px solid black;
  padding: 5px 10px;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mehr-articles div h3 {
  margin-right: 20px;
}
.mehr-articles div ion-icon {
  color: black;
  margin-left: 15px;
  rotate: 0deg;
  transition: rotate 0.7s;
}
.mehr-articles div ion-icon.rotate {
  rotate: 180deg;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-multiple/article-option-group-multiple.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,kBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAME;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,4BAAA;AAHN;AAMI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;AAJN;AAQE;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AANJ;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AASA;EACE,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AANF;;AASA;EACE,eAAA;EACA,gCAAA;AANF;AC1DE;ED8DF;IAII,kBAAA;EAJF;AACF;;AAMA;EACE,WAAA;EACA,YAAA;AAHF;;AAKA;EACE,uBAAA;EAAA,kBAAA;AAFF;AAGE;EACE,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAEI;EACE,kBAAA;AAAN;AAEI;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AAAN;AACM;EACE,cAAA;AACR","sourcesContent":["@import '../../../theme/mixins';\n\nion-item {\n  width: 100%;\n  margin-bottom: 6px;\n}\n\n.checkbox-price {\n  color: #b5b5b5;\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.price {\n  margin-right: 10px;\n}\n\n.qty {\n\n  &__btn {\n    width: 24px;\n    height: 24px;\n    margin: 0 !important;\n    box-shadow: none;\n    --box-shadow: none;\n\n    button {\n      box-shadow: unset !important;\n    }\n\n    span {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      height: 19px;\n      color: white;\n    }\n  }\n\n  .qty-number {\n    margin: 0 4px;\n    text-align: center;\n    min-width: 15px;\n    color: var(--ion-color-primary);\n  }\n}\n\nion-checkbox {\n  margin: 0 12px 0 0;\n}\n\napp-tag {\n  display: inline-block;\n}\nion-item{\n  background: #FFFFFF;\n  border: 0.5px solid #E2DCD5;\n  border-radius: 10px;\n  margin: 10px 0px;\n\n}\nion-label {\n  font-size: 14px;\n  font-family: AppFont, sans-serif;\n  @include desktop {\n    padding-right: 5px;\n  }\n}\n.item-img {\n  width: 50px;\n  padding: 7px;\n}\n.mehr-articles {\n  width: fit-content;\n  div {\n    background: white;\n    border: 1px solid black;\n    padding: 5px 10px;\n    border-radius: 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    h3 {\n      margin-right: 20px;\n    }\n    ion-icon {\n      color: black;\n      margin-left: 15px;\n      rotate: 0deg;\n      transition: rotate 0.7s ;\n      &.rotate {\n        rotate: 180deg;\n      }\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
